<template>
	<v-row no-gutters class="complete-quests__tile">
		<v-col cols="12" sm="6" md="6"
			class="complete-quests__content d-flex flex-column align-center align-sm-start justify-center">
			<div class="complete-quests__title">
				Complete Quests & Get Rewarded.
			</div>

			<div class="complete-quests__description mt-3">
				Download our mobile application and start earning today!
			</div>

			<button @click="redirectTORewards()" class="complete-quests__button button--primary rounded-pill d-flex">
				Get Rewards
			</button>
		</v-col>

		<v-col cols="12" sm="6" md="6">
			<img src="../../icons/CompleteQuest.svg" class="complete-quests__image w-100 mt-4 mt-md-0" />
		</v-col>

	</v-row>
</template>



<script setup>

import { useRouter } from 'vue-router';
import { scrollToTop } from "@/utils/utils.ts";

const router = useRouter();
const redirectTORewards = () => {
  router.push({ path: "/rewards" });
  scrollToTop();
};
</script>